import {Component, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {first, takeUntil} from 'rxjs/operators';

import {fuseAnimations} from '@fuse/animations';
import {CategoryService} from "../../../services/category.service";
import {AlertService} from "../../../services";
import {NestedTreeControl} from "@angular/cdk/tree";
import {Category} from "../../../models/category";
import {MatTreeNestedDataSource} from "@angular/material/tree";
import {User} from "../../../models";
import {NewNoteDialogComponent} from "../../../note/dialog/newNoteDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {NoteService} from "../../../note/service/note.service";
import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../../../@fuse/services/translation-loader.service";

@Component({
    selector: 'customer-details-sidebar',
    templateUrl: './details-sidebar.component.html',
    styleUrls: ['./details-sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CustomerDetailsSidebarComponent implements OnInit, OnDestroy {
    folders: any[];
    filters: any[];
    tags: any[];
    accounts: object;
    selectedAccount: string;
    categories: any[];
    loadingIndicator: boolean;
    treeControl = new NestedTreeControl<Category>(node => node.children);
    dataSource = new MatTreeNestedDataSource<Category>();
    @Input() user: User;
    newNoteDialogRef: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {Router} _router
     */
    constructor(
        private _router: Router,
        private categoryService: CategoryService,
        private alertService: AlertService,
        public _matDialog: MatDialog,
        private noteService: NoteService,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.translationLoader.loadTranslations(polish, english);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    newNote(): void {
        this.newNoteDialogRef = this._matDialog.open(NewNoteDialogComponent, {
            panelClass: 'new-note-dialog',
            data      : {
                action : 'new-note',
                customer: this.user.id
            },
            width: '550px',
        });

        this.newNoteDialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                this.noteService.create(response.getRawValue()).pipe(first())
                    .subscribe(res => {
                        window.location.reload();
                    });

                this.newNoteDialogRef.close();

            }, (err) => {
                console.log(err);
            });
    }
}
